import { type FC, type HTMLAttributes } from 'react'
import { useTheme } from '@mui/material/styles'

import * as styles from './styles'

const DialogLinkButton: FC<HTMLAttributes<HTMLButtonElement>> = (props) => {
  const theme = useTheme()

  return <button type="button" css={styles.actionButton(theme)} {...props} />
}

export default DialogLinkButton
